import type { ReactNode } from "react";

import { EmptyState } from "../../components/EmptyState";
import { nl } from "../../i18n/nl";
import { useMe } from "../auth/session";
import styles from "./admin.module.css";

/** `/beheer/*`: the API answers 403 anyway; this shows students a clear page instead. */
export function RequireModerator({ children }: { children: ReactNode }) {
  const me = useMe();
  if (me.data?.role === "moderator") return children;
  if (me.isPending) return null;
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{nl.admin.onlyModerators}</h1>
      <EmptyState title={nl.admin.onlyModeratorsText} />
    </div>
  );
}
